import { Component, Input } from '@angular/core';

import { NotificationService } from './../../../notification.service';
import { SharedClientService } from '../../../../../client/shared/services/shared-client.service';
import { CookieService } from '../../../../../../providers/cookie.service';
import { AuthService } from '../../../../../../providers/auth.service';
import { TimeService } from '../../../../../../shared/services/time.service';


export class NotificationBarTypeClientTimezoneConflictComponent {
	 public notification: any;

	public isTimezoneUpdating: boolean = false;

	constructor(
		private authService: AuthService,
		private cookieService: CookieService,
		private timeService: TimeService,
		private clientService: SharedClientService,
		private notificationService: NotificationService) { }

	// Events
	public onTimezoneChangeClick(changeIt: boolean): void {
		if (changeIt) {
			if (this.isTimezoneUpdating) {
				return;
			}

			this.isTimezoneUpdating = true;
			this.clientService.postClient(String(this.authService.userId), {timezone: this.notification.browserTimezone}).subscribe(
				(response) => {
					this.isTimezoneUpdating = false;
					this.timeService.setAppTimezone(this.notification.browserTimezone);
					this.emitEvent();

					// reload app
					window.location.reload();
				},
				(err) => {
					this.isTimezoneUpdating = false;
				}
			);
		} else {
			let appCookie = this.cookieService.get();
			if (!appCookie) {
				return;
			}
			appCookie.timezoneSettings = {
				showTimezoneConflict: false
			};
			this.cookieService.set(appCookie);

			this.emitEvent();
		}
	}

	// Helpers
	private emitEvent(): void {
		this.notificationService.emitEventAction({
			action: 'remove-notification',
			data: {
				identifier: this.notification.notification_type
			}
		});
	}
static ctorParameters() { return [ { type: AuthService }, { type: CookieService }, { type: TimeService }, { type: SharedClientService }, { type: NotificationService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/shared/notification/bar/type/client-timezone-conflict/timezone-conflict.component.ts